import { ISeat, IRacket } from '@/pages/Cart/types';
import { dateRestFormat } from '@/utils';

export function createAttachedRacket(seat: ISeat): IRacket {
  const isPadel = seat.arenaTitle?.toLowerCase().includes('padel');

  return {
    id: seat.id * 1000 + Date.now(),
    date: seat.date,
    time: seat.time,
    price: 500,
    count: 1,
    available: isPadel ? 25 : 12,
    startTimeRacket: dateRestFormat(new Date()),
    title: 'Аренда ракеток',
    created_at: null,
    updated_at: null,
    courtTitle: seat.courtTitle,
    courtId: seat.courtId,
    courtType: isPadel ? 'Padel' : 'Tennis',
  };
}

export function generateRacketKey(seat: ISeat): string {
  return `court-${seat.courtId}-${seat.date}-${seat.time}`;
}

export function isRacketAttachedToCourt(racket: IRacket): boolean {
  return !!(racket.courtTitle && racket.courtId);
}

export function isRacketForCourt(racket: IRacket, seat: ISeat): boolean {
  return (
    racket.courtId === seat.courtId &&
    racket.date === seat.date &&
    racket.time === seat.time
  );
}
